import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-multi-dropdown',
  templateUrl: './multi-dropdown.component.html',
  styleUrl: './multi-dropdown.component.scss'
})
export class MultiDropdownComponent implements OnChanges {
  @Input() control!: FormControl;
  @Input() submitted: boolean = false;
  @Input() items: any[] = [];
  @Input() labelProperty: string = "";
  @Input() valueProperty: string = "";
  @Input() placeholder: string = "";
  @Input() errorMessage: string = "";
  @Input() multiple: boolean = false;
  @Input() searchable: boolean = false;
  @Input() clearable: boolean = false;
  @Input() image: boolean = false;
  @Input() max: number = 1;
  @Output() change: EventEmitter<any> = new EventEmitter<any>();
  isMaxLimited: boolean = false;
  @Input() isDisabled: boolean = false;
  @Input() colorByMandatory: boolean = false;

  ngOnInit(): void {
    if (this.isDisabled) {
      this.control.disable();
    }
    else {
      this.control.enable();
    }
  }
  // @Input() set disabled(value: boolean) {
  //   if (value) {
  //     this.control.disable();
  //   } else {
  //     this.control.enable();
  //   }
  // }

  onChange(value: any) {
    if (this.multiple && this.control.value && this.control.value.length > this.max) {
      // Set the value back to the last valid selection
      this.control.setValue(this.control.value.slice(0, this.max));
      // Optionally show an alert, toast, or some other message to inform the user
      this.isMaxLimited = true;
      return;
    }
    this.isMaxLimited = false;
    this.change.emit(value);
  }

  onSearch(value: any) {
    this.change.emit(value);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['items']) {
      // Handle the items change, if necessary
      // For instance, update an internal component state or force update
    }
  }

  getOptionStyle(item: any) {
    if (!this.colorByMandatory) {
      return {};
    }
    const isMandatory = item?.isMandatory === true || item?.disabled === true;
    return isMandatory ? { color: '#6c757d' } : {};
  }

  getLabelStyle(item: any) {
    if (!this.colorByMandatory) {
      return {};
    }
    const isMandatory = item?.isMandatory === true || item?.disabled === true;
    return isMandatory ? { color: '#6c757d' } : {};
  }

  isRemovable(item: any): boolean {
    if (!this.colorByMandatory) {
      return true;
    }
    const isMandatory = item?.isMandatory === true || item?.disabled === true;
    return !isMandatory;
  }
}
